(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("kontentCore", [], factory);
	else if(typeof exports === 'object')
		exports["kontentCore"] = factory();
	else
		root["kontentCore"] = factory();
})(self, function() {
return 